// src/pages/AdminPage/hooks/useAdminStats.ts
import { useState, useEffect, useCallback } from "react";
import { adminAPI } from "../utils/adminApi";
import type { DashStats, DayStats } from "../utils/adminTypes";

export function useAdminStats(onError?: (msg: string) => void) {
  const [stats, setStats] = useState<DashStats | null>(null);
  const [growth, setGrowth] = useState<DayStats[]>([]);
  const [growthPeriod, setGrowthPeriod] = useState<"week" | "month" | "year">(
    "month",
  );
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [statsRes, growthRes] = await Promise.all([
        adminAPI.getStats(),
        adminAPI.getUserGrowth(growthPeriod),
      ]);
      setStats(statsRes.data);
      setGrowth(growthRes.data || []);
    } catch {
      onError?.("Statistika yuklanmadi");
    } finally {
      setLoading(false);
    }
  }, [growthPeriod, onError]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    stats,
    growth,
    growthPeriod,
    setGrowthPeriod,
    loading,
    reload: load,
  };
}
